import React from 'react'
import Tick from '../../assets/tick.svg'
import { Loader2Icon } from 'lucide-react'
import { useSelector } from 'react-redux';

const SaveButton = ({onClick, className, isLoading, disabled}) => {

  const { data, loading } = useSelector((state) => state.admin);

    
  const isAllowedRole = data?.user_role === "SUPER_ADMIN" || data?.user_role === "ADMIN";

  return (
    <button 
      onClick={onClick} 
      disabled={ disabled || isLoading || !isAllowedRole}
      className={`flex items-center text-white gap-2 bg-custom-yellow pt-2 pb-2 pl-4 pr-4 rounded-lg 
        ${disabled || isLoading || !isAllowedRole ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}`}
    >
      {isLoading ? (
        <Loader2Icon className='animate-spin' />
      ) : (
        <img src={Tick} alt="tick" />
      )}
      Änderungen speichern

    </button>
  )
}

export default SaveButton